import { render, staticRenderFns } from "./PurchaseHistoryModal.html?vue&type=template&id=b59cfa6c&external"
import script from "./PurchaseHistoryModal.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseHistoryModal.ts?vue&type=script&lang=ts&external"
import style0 from "./PurchaseHistoryModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports